import React from "react"
import { Container } from "reactstrap"
import CustomAlert from "../layout/CustomAlert"
import { Trans } from "@lingui/react"
import { connect, useSelector } from "react-redux"
import CashOutErrorList from "./CashoutErrorList"
import StellarLoader from "../layout/StellarLoader"

const headerStyle = {
  color: "#E36F1E",
  fontFamily: "quicksand",
  fontWeight: "bolder",
  fontSize: "1.2rem",
  textAlign: "center",
  paddingBottom: "0.5em",
}

function CashOutError() {
  const { isLoading } = useSelector((state) => ({
    isLoading: state.vlsaMembersLoadingStarted,
  }))

  if (isLoading) {
    return <StellarLoader />
  }

  return (
    <Container>
      <h4 style={headerStyle}>
        <Trans id="title_copy.end_of_cycle_cash_out">End-cycle cash out</Trans>
      </h4>
      <CustomAlert color="danger">
        <h4>
          <Trans id="alert.failed">Failed</Trans>
        </h4>
        <span>
          <Trans id="alert.repay_loans_message">
            Repay the loans these members have
          </Trans>
        </span>
      </CustomAlert>
      <CashOutErrorList />
    </Container>
  )
}

CashOutError.propTypes = {}

export default connect(null, null)(CashOutError)
